// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue              from 'vue'
import BootstrapVue     from 'bootstrap-vue'
import BabelPolyfill    from 'babel-polyfill'
import Application      from './application'

Vue.config.productionTip = false;

Vue.use( BootstrapVue );

/* eslint-disable no-new */
new Vue
    (
        {
            el:       '#application',
            template: '<Application/>',
            components: {
                Application,
                BootstrapVue,
                BabelPolyfill
            }
        }
    );



// WEBPACK FOOTER //
// ./src/main.js